import styles from "./question-component.module.css";
import { useAiReadiness } from "../../../context/AiReadinessContext.jsx";
import ProgressIndicator from "./ProgressIndicator";
import { useLocation } from "react-router-dom";
import { routesLinks } from "../../../utils/RouteConstants";

const AiReadinessQuestionSelection = () => {
  const location = useLocation()
  const {
    goToStep, questions, addUserResponse, currentIndex, setCurrentIndex, submitForm,
    selectedOptionIndex, setSelectedOptionIndex, step
  } = useAiReadiness();
  const currentQuestion = questions[currentIndex];
  const handleNext = async () => {
    if (selectedOptionIndex === null) return alert("Please select an option first!");
    // Store the response in context
    if (currentQuestion) {
      addUserResponse(currentQuestion._id, selectedOptionIndex);
    }
    if (currentIndex < questions.length - 1) {
      setCurrentIndex(currentIndex + 1);
      setSelectedOptionIndex(null);
    } else {
      if (location.pathname == routesLinks.aiReadiness) {
        goToStep(2)
      } else {
        await submitForm();
        goToStep(3)
      }
    }
  };

  if (!currentQuestion) {
    return <div className={styles.maincontainer}>Loading questions...</div>;
  }

  return (
    <div className={styles.maincontainer}>
      <div className={styles.questionContainer}>
        <ProgressIndicator currentStep={currentIndex} totalSteps={7} />
        <div className={styles.questionNumber}>{`Q${currentIndex + 1}`}</div>
        <div className={styles.questionStyles}>{currentQuestion.question_text}</div>
        <div className={styles.radioOptions}>
          {currentQuestion.options.map((option) => (
            <div key={option.index}>
              <label>
                <input
                  type="radio"
                  name="option"
                  value={option.index}
                  checked={selectedOptionIndex === option.index}
                  onChange={(e) => setSelectedOptionIndex(parseInt(e.target.value))}
                />
                {option.option}
              </label>
            </div>
          ))}
        </div>
        <div className={styles.buttonContainer}>
          <button
            onClick={handleNext}
            className={selectedOptionIndex !== null ? styles.nextButtonEnabled : styles.nextButtonDisabled}
            disabled={selectedOptionIndex === null}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};
export default AiReadinessQuestionSelection;
